import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { Center, Spinner } from "@chakra-ui/react";
import { useAuth } from "../../auth/AuthProvider";

// The whole cabinet is admin-only: only users with an admins/{uid} record may
// enter. Anonymous -> login; authenticated-but-not-admin -> no-access.
export const PublisherPanelProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { status } = useAuth();

  if (status === "loading") {
    return (
      <Center h="100vh">
        <Spinner size="xl" color="brand.orange" thickness="3px" />
      </Center>
    );
  }
  if (status === "anon") return <Navigate to="/publishers/panel/login" replace />;
  if (status === "not-admin") return <Navigate to="/publishers/panel/no-access" replace />;

  return <>{children}</>;
};
